import {
    startListeningForWsEventUpdates,
    stopListeningForWsEventUpdates,
} from '../../../services/mainSocket';
import { BETCARD_WS_HANDLER_COMPONENT_NAME } from './constants';
// This file will be remove in future, please use mainSocketClass instead

/**
 * Creates ws listening for updates
 * @param {object} betCards betcards object
 * @param {string} wsHandlerComponentName unique name for this shared component for this set of betcards. Note that this is also used by MadeForYou
 * @return {void}
 */
export const startListeningForUpdates = (betCards, wsHandlerComponentName = BETCARD_WS_HANDLER_COMPONENT_NAME) => {
    startListeningForWsEventUpdates(getSubscriptionData(betCards), wsHandlerComponentName);
};

/**
 * Stops ws listening for updates
 * @param {object} betCards betcards object
 * @return {void}
 */
export const stopListeningForUpdates = (betCards) => {
    stopListeningForWsEventUpdates(
        getSubscriptionData(betCards)
    );
};

/**
 * Returns the data to listen for selection updates
 * @param {object} betCards object
 * @return {Array} The selections subscription data
 */
function getSubscriptionData(betCards) {
    let selectionsToSubscribe = [];
    betCards.map(pointer => pointer.selection_pointers.map(sel => selectionsToSubscribe.push(sel)));

    return selectionsToSubscribe;
}
